import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Component for scrolling to top
 *  everytime a new page is opened.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
